import * as React from 'react';
// @ts-ignore
import TopicsSectionTitle from 'groups/components/TopicsSectionTitle';

type Props = {
  title?: string;
  children?: React.ReactNode;
};

export default function NavigationListSection(props: Props) {
  return (
    <section className="NavigationList-section">
      {props.title && (
        <TopicsSectionTitle className="NavigationList-section-title">
          {props.title}
        </TopicsSectionTitle>
      )}
      {props.children}
    </section>
  );
}
